
export const AdminModule = {
    namespaced: true,
    state: {
        user: {},
        userDiscountStatus: {},
        orders: [],
        history: [],
        ordersCount: 0,
    },
    mutations: {
        set_orders_count(state, count) {
           state.ordersCount = count;
    },
        decrement_orders_count(state) {
            if (state.ordersCount > 0) {
                state.ordersCount--;
            }
        },
    },
    getters: {
        getOrdersCount(state) {
        return state.ordersCount;
        },
    },
    actions: {
        fetchOrdersCount: async function({ commit }, { axios, url }) {
            try {
                const response = await axios.get(url);

                const count = response.data.data.length
                commit('set_orders_count', count);
            } catch (err) {
                console.error("❌ fetchOrdersCount failed:", err);
            }
        }

    }


}
